import { Link } from 'react-router-dom';
import { ThreeLinkedDotsIcon } from '@grupoboticario/flora-react-icons';
import { isMobile } from 'core/use-cases/app/helpers';
import { DigitalGuide } from '../CycleGuide.style';
import { formatShortDate } from 'core/utilities';
import { catalogButtonClick } from '../events';
import { clickEvents } from 'ui/utilities/helpers/click-events';
import { Flex, FloraTypography } from '@grupoboticario/flora-react';
import { ButtonShowAll } from 'ui/components/primitives/Heading/Heading.styles';
import type { GuideComponent } from 'core/domains/content';

export const CycleGuideEud = ({
  catalogs,
  setOpenShareModal,
  setSelectedGuide,
}: GuideComponent) => {
  const hasMobile = isMobile();
  const cycleInfo = `Ciclo ${catalogs[0].cycleNumber} - 
    ${formatShortDate(catalogs[0].cycleStart)} a 
    ${formatShortDate(catalogs[0].cycleEnd)}`;
  const catalogWithPosition = { ...catalogs[0], position: 1 };
  return (
    <DigitalGuide.Container data-testid="cycle-guide-eud">
      <DigitalGuide.GridGuide
        direction="column"
        gap="$3"
        templateColumns={hasMobile ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'}
      >
        <div>
          <DigitalGuide.TitleContainer>
            <Flex>
              <FloraTypography
                fontSize="subtitle"
                as="h6"
                css={{ fontWeight: 400, color: '$medium-light-1', margin: 0 }}
                viewport={isMobile() ? 'mobile' : 'desktop'}
                onClick={() => {
                  clickEvents('click:ver-tudo', 'interaction_catalogos', 'ciclo-atual');
                }}
              >
                Guia Digital do ciclo
              </FloraTypography>
              <Link to="/guia-digital">
                <ButtonShowAll>Ver tudo</ButtonShowAll>
              </Link>
            </Flex>
          </DigitalGuide.TitleContainer>
          <DigitalGuide.SubTitle>Para compartilhar com seus clientes</DigitalGuide.SubTitle>
        </div>
        <div>
          <DigitalGuide.ShareContainer>
            <DigitalGuide.ImgGuide src={catalogs[0].banner} alt="Imagem do guia" />
            <DigitalGuide.CicleText>{cycleInfo}</DigitalGuide.CicleText>
            <DigitalGuide.ShareButton
              rightIcon={<ThreeLinkedDotsIcon size={16} />}
              data-flora="button"
              data-flora-text="compartilhar"
              onClick={() => {
                setOpenShareModal(true);
                setSelectedGuide(catalogWithPosition);
                catalogButtonClick(catalogWithPosition, 'click:abrir-modal-compartilhamento');
              }}
            >
              Compartilhar Guia Digital
            </DigitalGuide.ShareButton>
          </DigitalGuide.ShareContainer>
        </div>
      </DigitalGuide.GridGuide>
    </DigitalGuide.Container>
  );
};
